import { commonUtils } from '../common_utils';

const SPANKKI_MIN_LOAN_AMOUNT = 5000;
const SPANKKI_MAX_LOAN_AMOUNT = 50000;

export const spankki = {
    removeGreenEffect() {
        $('.greenFadeEffectSpankki').removeClass('updateSec');
    },
    loadYear(defaultMonths) {
        $('#spankkiLoanPeriod').empty();

        let startYear = 1,
            endYear = 12;
        for (let year = startYear; year <= endYear; year++) {
            $('#spankkiLoanPeriod').append(new Option(year, year * 12));
        }

        $('#spankkiLoanPeriod').val(defaultMonths);
    },
    slider() {
        let defaultMonths = $('#spankkiLoanPeriod').val();
        let loanAmount = $('#spankkiLoanAmount').val();

        $('.greenFadeEffectSpankki').addClass('updateSec');

        if (loanAmount < SPANKKI_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.spankki_min_loan_amount);
            loanAmount = SPANKKI_MIN_LOAN_AMOUNT;
            $('#spankkiLoanAmount').val(loanAmount);
        } else if (loanAmount > SPANKKI_MAX_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.spankki_max_loan_amount);
            loanAmount = SPANKKI_MAX_LOAN_AMOUNT;
            $('#spankkiLoanAmount').val(loanAmount);
        }

        spankki.loadYear(defaultMonths);
        defaultMonths = $('#spankkiLoanPeriod').val();

        if (loanAmount) {
            $.ajax({
                type: 'GET',
                url: Routing.generate('finance_spankki'),
                data: `loanAmount=${loanAmount}&loanPeriod=${defaultMonths}`,
                success(data) {
                    let loanData = data.spankki;
                    let installment = '-',
                        effective = '-',
                        nominal = '-';

                    if (loanData) {
                        installment =
                            loanData.monthlyPayment === null
                                ? '-'
                                : commonUtils.numberFormatByLocale(loanData.monthlyPayment.toFixed(2));

                        effective =
                            loanData.annualInterest === null
                                ? '-'
                                : commonUtils.numberFormatByLocale(loanData.annualInterest.toFixed(2));

                        nominal =
                            loanData.interest === null
                                ? '-'
                                : commonUtils.numberFormatByLocale(loanData.interest.toFixed(2));
                    }

                    $('#spankki_monthly_payment').html(installment);
                    $('#spankki_air').html(effective);
                    $('#spankki_mir').html(nominal);

                    setTimeout(spankki.removeGreenEffect, 1000);
                },
                error(jqXHR, textStatus, errorThrown) {
                    console.log('Spankki finance request failed', textStatus, errorThrown);
                },
            });
        }
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));
        let loanUrl = `${$('#spankkiLink').data('loan-url')}`;
        window.open(loanUrl, '_blank');
    },
};
